export const policyCoverageDetails = `query PolicyCoverageDetails(
    $sessionId: String!
    $contractNumbers: [String!]!
) {
    policyCoverageDetailsHealthCare(
        sessionId: $sessionId
        contractNumbers: $contractNumbers) {
        contractNumber
        titles
        insurances {
            id
            coverages
        }
    }
}`;
